<template>
  <div class="home_bg">
    <p class="title">欢迎你！{{user}}</p>
  </div>
</template>

<script>

export default {
  data() {
    return {
      user:localStorage.getItem('username')
    }
  },
  // 注册组件
  components: {

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

  },
  mounted() {

  }
}
</script>

<style scoped>
.home_bg{
  width: 100%;
  height: 100%;
  /* background: url("../../assets/img/back.jpg") no-repeat; */
}

.title{
  height: 100%;
  font-size: 30px;
  color: #0f215d;
  margin: auto;
  line-height: 837px;
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/views/home/home.vue